// extracted by mini-css-extract-plugin
export var active = "_c2-7";
export var blink = "_c2-8";
export var dropDownSelector = "_c2-4";
export var dropDownWrapper = "_c2-3";
export var fakeCursor = "_c2-6";
export var fontSizeButton = "_c2-9";
export var formQuillEditor = "_c2-0";
export var pressed = "_c2-a";
export var qlBlank = "_c2-1";
export var textFormattingToolbar = "_c2-2";
export var textToolbarOption = "_c2-5";